import type { ConceptDef } from '../types';

export const tactLocations: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-locations',
  label: 'Expressive Locations',
  category: 'Expressive',
  description: 'Show a place; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🏞 park' },
      { prompt: '🏖 beach' },
      { prompt: '🌲 forest' },
      { prompt: '⛰ mountain' },
      { prompt: '🏟 stadium' },
      { prompt: '🛝 playground' },
      { prompt: '🚉 station' },
      { prompt: '✈ airport' },
    ],
  },
};
